// TSS vite/04 §"Endpoint paths". baseURL ya incluye /api/v1.
// Receptoras: entidad liviana, basta el `number` (admin-recipients.md).

export const recipientPaths = {
    list:   ()   => 'admin/recipients',
    detail: (id) => `admin/recipients/${id}`,
};
